module.exports = __webpack_public_path__ + "static/branding-c173b0b868bfad51930fb3179a9eec00.svg";